<template>
  <div class="row col-md-12 reduzirFonte" v-if="pessoaJuridica">
    <ConfirmacaoDados v-model="mostrarModalConfirmacao" @confirmar="substituirDados" @fechar="fecharModal" :novosDados="novosDados" :mapeamentoCampos="mapeamentoCampos"/>
    <div class="form-group col-md-12 col-lg-12 col-xl-6">
      <label for="cnpj" class="required">CNPJ</label>
      <input type="text" v-mask="mascaraCnpj" @change="buscarCnpj" v-model="formulario.informacoes.empresariais.cpf_cnpj" :disabled="desabilitar" class="form-control campo-DocumentoCpfCnpjAlfanumericoUppercase" id="cnpj">
      <div class="avisoDanger text-left mt-1">{{listaDeErros.cpf_cnpj}}</div>
    </div>
    <div class="form-group col-md-12 col-lg-12 col-xl-6">
      <label for="nome" class="required">Nome (Razão Social)</label>
      <input type="text" v-model="formulario.informacoes.empresariais.nome" :disabled="desabilitar" class="form-control" id="nome">
      <div class="avisoDanger text-left mt-1">{{listaDeErros.nome}}</div>
    </div>
    <div class="form-group col-md-12 col-lg-12 col-xl-6">
      <label for="nome_fantasia" class="required">Nome Fantasia</label>
      <input type="text" v-model="formulario.informacoes.empresariais.nome_fantasia" :disabled="desabilitar" class="form-control" id="nome_fantasia">
      <div class="avisoDanger text-left mt-1">{{listaDeErros.nome_fantasia}}</div>
    </div>
    <div class="form-group col-md-12 col-lg-12 col-xl-6">
      <label for="inscricao_estadual">Inscrição Estadual</label>
      <input type="text" v-model="formulario.informacoes.empresariais.inscricao_estadual" :disabled="desabilitar" class="form-control" id="inscricao_estadual">
      <div class="avisoDanger text-left mt-1">{{listaDeErros.inscricao_estadual}}</div>
    </div>
    <div class="form-group col-md-12 col-lg-12 col-xl-6">
      <label for="inscricao_municipal">Inscrição Municipal</label>
      <input type="text" v-model="formulario.informacoes.empresariais.inscricao_municipal" :disabled="desabilitar" class="form-control" id="inscricao_municipal">
      <div class="avisoDanger text-left mt-1">{{listaDeErros.inscricao_estadual}}</div>
    </div>
    <div class="form-group col-md-12 col-lg-12 col-xl-6" v-if="false">
      <label for="representante_legal" class="required">Representante Legal</label>
      <v-select
        class="style-chooser"
        v-model="formulario.informacoes.empresariais.representante_legal"
        :options="combosRepresentanteLegal"
        @search="eventoDigitarBuscaPorRepresentanteLegal"
        :disabled="desabilitar"
        :filterable="false">
        <template v-slot:no-options>
          <em>Nenhum registro encontrado.</em>
        </template>
      </v-select>
      <div class="avisoDanger text-left mt-1">{{listaDeErros.representante_legal}}</div>
    </div>
    <div class="col-12">
      <div class="custom-control custom-switch">
        <input type="checkbox" v-model="formulario.informacoes.empresariais.opt_simples" class="custom-control-input" id="opt_simples" :disabled="desabilitar">
        <label class="custom-control-label" for="opt_simples">Opta pelo simples</label>
        <div class="avisoDanger text-left mt-1">{{listaDeErros.opt_simples}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import util from '@/util'
import constants from '@/util/constants'
import cnpj from '@/util/cnpj'
import cnpjMask from '@/util/cnpjMask'
import { mapActions, mapState } from 'vuex'
import ConfirmacaoDados from '@/components/layout/confirmacaoDados/ConfirmacaoDados.vue'
import mensagens from '@/util/mensagens'

export default {
  name: 'informacoes-empresariais',
  components: {
    ConfirmacaoDados
  },
  props: {
    pessoaJuridica: {
      type: Boolean,
      default: false
    },
    buscarInformacoesDoCnpj: Function,
    desabilitar: {
      type: Boolean,
      default: false
    },
    listaDeErros: {
      type: [Array, Object],
      default: () => []
    }
  },
  computed: {
    ...mapState('escritorios', ['formulario', 'listaUsuariosRepresentanteLegal', 'flagsDeControle']),
    mascaraCnpj () {
      return cnpjMask.obterMascaraCnpj(this.formulario.informacoes.empresariais.cpf_cnpj)
    }
  },
  data: () => {
    return {
      combosRepresentanteLegal: [],
      timeOutDigitacaoNocombo: null,
      mostrarModalConfirmacao: false,
      idEmpresa: null,
      novosDados: {},
      mapeamentoCampos: {
        nome: 'Nome Empresarial',
        nome_fantasia: 'Nome Fantasia',
        fone: 'Telefone',
        email: 'E-mail',
        cep: 'CEP',
        endereco: 'Endereço',
        bairro: 'Bairro',
        cidade: 'Cidade',
        numero: 'Número',
        complemento: 'Complemento',
        uf: 'Estado'
      },
      cnpjAnterior: null
    }
  },

  async mounted () {
    this.idEmpresa = this.$route.params.id
    // await this.obterRepresentatesLegais()
  },
  methods: {
    ...mapActions('escritorios', ['ActionDefinirListaUsuariosRepresentateLegal']),
    async buscarCnpj () {
      const cnpjNormalizado = cnpj.normalizarCnpj(this.formulario.informacoes.empresariais.cpf_cnpj)
      if (!cnpjNormalizado || cnpjNormalizado.length !== 14) {
        return
      }
      try {
        this.definirFlagCarregandoDados(true, mensagens.carregandoDadosEdicao)
        const resposta = await this.buscarInformacoesDoCnpj(cnpjNormalizado)
        const respostaComSucesso = resposta?.retorno?.sucesso === true
        if (!respostaComSucesso || resposta === null) {
          const mensagem = resposta?.retorno?.mensagem ?? mensagens.falhaServidorCarregandoDados
          util.criarAlertaToastDeErro(this, 'Aviso', mensagem)
          return
        }
        const novosDados = {
          cpf_cnpj: cnpjNormalizado,
          nome: resposta.retorno.dados.nome,
          nome_fantasia: resposta.retorno.dados.fantasia,
          fone: resposta.retorno.dados.telefone,
          email: resposta.retorno.dados.email,
          cep: resposta.retorno.dados.cep,
          endereco: resposta.retorno.dados.logradouro,
          bairro: resposta.retorno.dados.bairro,
          cidade: resposta.retorno.dados.municipio,
          numero: resposta.retorno.dados.numero,
          complemento: resposta.retorno.dados.complemento,
          uf: { code: resposta.retorno.dados.uf, label: resposta.retorno.dados.uf }
        }
        this.sincronizarDados(novosDados)
      } catch (e) {
        console.log(e)
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorCarregandoDados)
      } finally {
        this.definirFlagCarregandoDados(false, '')
      }
    },

    fecharModal () {
      this.mostrarModalConfirmacao = false
    },
    substituirDados (novosDados) {
      this.cnpjAnterior = novosDados.cpf_cnpj
      this.preencherFormulario(novosDados)
      this.mostrarModalConfirmacao = false
    },

    sincronizarDados (dados) {
      const informacoesDiferentes = cnpj.normalizarCnpj(this.cnpjAnterior) !== cnpj.normalizarCnpj(dados.cpf_cnpj)
      this.novosDados = dados
      if (informacoesDiferentes && !util.valorVazio(this.formulario.informacoes.empresariais.nome)) {
        this.mostrarModalConfirmacao = true
        return
      }

      this.preencherFormulario(dados)
    },
    preencherFormulario (dados) {
      this.formulario.informacoes.empresariais.nome = dados.nome
      this.formulario.informacoes.empresariais.nome_fantasia = dados.nome_fantasia
      this.formulario.contato.fone = dados.fone || this.formulario.contato.fone
      this.formulario.contato.email = dados.email || this.formulario.contato.email
      this.formulario.endereco.cep = dados.cep || this.formulario.endereco.cep
      this.formulario.endereco.endereco = dados.endereco || this.formulario.endereco.endereco
      this.formulario.endereco.bairro = dados.bairro || this.formulario.endereco.bairro
      this.formulario.endereco.cidade = dados.cidade || this.formulario.endereco.cidade
      this.formulario.endereco.numero = dados.numero || this.formulario.endereco.numero
      this.formulario.endereco.complemento = dados.complemento
      this.formulario.endereco.uf = dados.uf
    },

    eventoDigitarBuscaPorRepresentanteLegal (valorDigitadoParaBusca, callbackFlagCarregamento) {
      clearTimeout(this.timeOutDigitacaoNocombo)
      let referenciaObjetoDaView = this

      this.timeOutDigitacaoNocombo = setTimeout(function () {
        referenciaObjetoDaView.obterRepresentatesLegais(valorDigitadoParaBusca, callbackFlagCarregamento)
      }, constants.tempoParaAguardarDigitacaoNoCombo)
    },

    async obterRepresentatesLegais (valorDigitadoParaBusca, callbackFlagCarregamento) {
      if (!util.valorEhNulo(callbackFlagCarregamento)) {
        callbackFlagCarregamento = true
      }
      let parametrosRequisicao = {
        'registrosPorPagina': constants.defaultRegistrosCombo,
        'filtros': { 'nome': valorDigitadoParaBusca, 'empresa_id': this.idEmpresa }
      }

      await this.ActionDefinirListaUsuariosRepresentateLegal(parametrosRequisicao)
      this.combosRepresentanteLegal = this.listaUsuariosRepresentanteLegal.map(registro => {
        return { label: registro.nome ?? registro.email, code: registro.id }
      })
      callbackFlagCarregamento = false
    },
    definirFlagCarregandoDados (status, mensagem) {
      this.flagsDeControle.carregandoDados.status = status
      this.flagsDeControle.carregandoDados.mensagem = mensagem
    }
  }
}
</script>
